import { cmsGraphQLClient } from '@app/graphQLClient';
import { useGroupedMakers } from '@app/hooks/useGroupedMakers';
import Advertisement from '@components/Advertisements/RectangleAd';
import Jumbotron from '@components/Jumbotron';
import { Layout } from '@components/Layout';
import Filter from '@components/Maker/Filter';
import Makers from '@components/Maker/Makers';
import { dehydrate } from '@tanstack/react-query';
import { Empty } from 'antd';
import { TWO_HOURS_IN_MILLISECONDS } from 'mdc-constants';
import { GetStaticProps } from 'next';
import { FC, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { GetManufacturersVariables, useGetManufacturers } from 'services/graphql/cms';
import { useSubscription } from 'services/hooks/queries/useSubscription';
import { queryClient } from 'services/queryClient';

const ExploreActivitySubCategoryPage: FC = () => {
  const { formatMessage } = useIntl();
  const f = (id: string): string => formatMessage({ id: `maker.${id}` });

  const title = f('title');

  const metaData = {
    title,
  };

  const { isSubscribed } = useSubscription();

  const [nameQuery, setNameQuery] = useState<string>();
  const { makers, alphabet } = useGroupedMakers(nameQuery);

  const keys = useMemo(() => Array.from(makers.keys()), [makers]);

  return (
    <Layout meta={metaData}>
      <main>
        <Jumbotron breadCrumb={[0]} pageName="maker" title={title} />

        <Filter setNameQuery={setNameQuery} alphabet={alphabet} />
        {!isSubscribed ? (
          <div style={{ padding: '0 24px', margin: '16px 0 24px 0' }}>
            <Advertisement />
          </div>
        ) : null}

        {keys.map((item) => {
          const maker = makers.get(item);

          return <Makers letter={item} key={item} items={maker} />;
        })}

        {!keys.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

        {!isSubscribed ? (
          <div style={{ padding: '0 24px', margin: '16px 0 24px 0' }}>
            <Advertisement />
          </div>
        ) : null}
      </main>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const variables: GetManufacturersVariables = {
    limit: 1000,
  };

  await queryClient.prefetchQuery({
    queryKey: ['getManufacturers', variables],
    queryFn: useGetManufacturers.fetcher(cmsGraphQLClient, variables),
    staleTime: TWO_HOURS_IN_MILLISECONDS,
    gcTime: TWO_HOURS_IN_MILLISECONDS,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

export default ExploreActivitySubCategoryPage;
